import { createBrowserHistory } from 'history'
import configureStore from '@/config/redux/configureStore'
import { ReduxState } from './types'

const initialState: ReduxState = {} as ReduxState

/**
 * Initialize redux store.
 */
const { store, persistor } = configureStore(initialState)

export const getStore = () => store
export const getPersistor = () => persistor
export const getState = () => getStore()?.getState() as ReduxState
export const getHistory = () => createBrowserHistory()

export default { getStore, getPersistor, getState, getHistory }
